<div
  echarts
  #chart
  [options]="chartOption"
  [autoResize]="true"
  [initOpts]="initOpts"
  (chartInit)="onChartInit($event)"
  class="echart-graphs"
></div>
